var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.475 20.725L0.225 12.425C-0.075 12.125 -0.075 11.625 0.225 11.325L1.325 10.225C1.625 9.925 2.125 9.925 2.425 10.225L8.625 16.475C8.825 16.675 9.175 16.675 9.375 16.475L21.525 4.225C21.825 3.925 22.325 3.925 22.625 4.225L23.725 5.325C24.025 5.625 24.025 6.125 23.725 6.425L9.575 20.725C9.275 21.075 8.775 21.075 8.475 20.725V20.725Z"}));
}

Check.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Check;

Check.default = Check;
